import { useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { AuthLayout } from "@/components/catalyst/AuthLayout";
import { Button } from "@/components/catalyst/Button";
import { Heading } from "@/components/catalyst/Heading";
import { Logo } from "@/components/Logo";
import { waitForSubscriptionActive } from "@/pages/checkout/wait-for-subscription";

/**
 * Bridge page for Stripe redirects (3DS, bank transfers, etc.).
 * Polls subscription status until webhook processing completes, then navigates to dashboard.
 */
export function CheckoutReturnPage() {
	const navigate = useNavigate();
	const [isError, setIsError] = useState(false);

	useEffect(() => {
		waitForSubscriptionActive()
			.then((active) => {
				if (active) {
					navigate({ to: "/dashboard" });
				} else {
					setIsError(true);
				}
			})
			.catch(() => setIsError(true));
	}, [navigate]);

	if (isError) {
		return (
			<AuthLayout>
				<div className="flex max-w-sm flex-col items-center gap-4 text-center">
					<Logo />
					<Heading>Something went wrong</Heading>
					<p className="text-base-content/60 text-sm">
						Your payment was received but we're having trouble activating your
						subscription. Please try again.
					</p>
					<Button
						color="dark/white"
						onClick={() => navigate({ to: "/dashboard" })}
					>
						Go to Dashboard
					</Button>
				</div>
			</AuthLayout>
		);
	}

	return (
		<AuthLayout>
			<div className="flex flex-col items-center gap-4 text-center">
				<Logo />
				<Heading>Setting up your account...</Heading>
				<p className="text-base-content/60 text-sm">
					Please wait while we activate your subscription.
				</p>
				<span className="loading loading-spinner loading-md" />
			</div>
		</AuthLayout>
	);
}
